import { IMPLEMENTATION_PLAN_NAMES, STAGES_NAMES } from 'components/BusinessToolForm/Sections/ImplementationPlan/utils/form';

import { ol, ul } from '../helpers';

const STAGES_INSTRUCTIONS = {
  [STAGES_NAMES.STAGE]: {
    name: 'Implementierungsplan',
    instruction:
      'Wenn Sie Fragen zum Projektzeitplan beantworten, gehen Sie wie folgt vor:' +
      ol([
        'Skizzieren Sie die wichtigsten Phasen von der Konzeption bis zum Launch.',
        'Geben Sie die geschätzte Dauer für jede Phase an.',
        'Geben Sie an, in welcher Phase Sie sich aktuell befinden.',
      ]),
    exampleOne: ul([
      'Konzept & Design: 6 Monate.',
      'Prototyping & Tests: 9 Monate.',
      'Einrichtung der Fertigung: 3 Monate.',
      'Marketing & Launch-Vorbereitung: 2 Monate.',
      'Derzeit in der Phase der Einrichtung der Fertigung.',
    ]),
    exampleTwo: ul([
      'Konzeptphase: 3 Monate.',
      'Design und Prototyping: 6 Monate.',
      'Tests und Iteration: 4 Monate.',
      'Finalisierung und Produktion: 3 Monate.',
      'Derzeit in der Phase Tests und Iteration.',
    ]),
  },
};

export const IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS = {
  [IMPLEMENTATION_PLAN_NAMES.STAGES]: STAGES_INSTRUCTIONS,
};
